import React, {useState, useEffect} from 'react'
import {toast} from 'react-toastify'
import Swal from 'sweetalert2'
import Button from '../../components/Button/Button'
import {
  getConfiguration,
  deleteConfiguration,
  handleSubmit,
  getConfigurationById,
  valiconfigurationLevelForm,
  cancelSubmit,
} from './ConfigurationFunctions'
import {AlertProps} from '../../data/AlertDefaults'
import {changeTextCapital} from '../../../_metronic/helpers/AssetHelpers'

const Configuration = () => {
  const [configuration, setConfiguration] = useState([
    {
      id: '',
      salaryComponentName: '',
      salaryComponentValue: '',
      salaryComponentUnit: '',
    },
  ])

  const [APIStatus, setAPIStatus] = useState({loading: false, error: null, submitLoading: false})
  const [editId, setEditId] = useState(null)
  const [inputField, setInputField] = useState({
    salaryComponentName: '',
    salaryComponentValue: '',
    salaryComponentUnit: '',
  })

  const [inputError, setInputError] = useState<any>({})
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false)

  useEffect(() => {
    getConfiguration(setConfiguration, setAPIStatus)
  }, [])

  const initialState = {
    salaryComponentName: '',
    salaryComponentValue: '',
    salaryComponentUnit: '',
  }

  const configurationNameOptions = [
    {value: 'basic', label: 'Basic', unit: '%', displayUnit: '%'},
    {value: 'HRA', label: 'HRA', unit: '%', displayUnit: '%'},
    {value: 'DA', label: 'DA', unit: '%', displayUnit: '%'},
    {value: 'education', label: 'Education', unit: 'Rs/Monthly', displayUnit: 'Rs/Monthly'},
    {value: 'LTA', label: 'LTA', unit: '%', displayUnit: '%'},
    {value: 'variable', label: 'Variable', unit: 'Rs/Monthly', displayUnit: 'Rs/Monthly'},
    {value: 'mealCoupon', label: 'Meal Coupon', unit: 'Rs/Coupon', displayUnit: 'Rs/Coupon'},
    {value: 'PF', label: 'PF', unit: '%', displayUnit: '%'},
    {value: 'PT', label: 'PT', unit: 'Rs/Monthly', displayUnit: 'Rs/Monthly'},
    {value: 'ESIC', label: 'ESIC', unit: '%', displayUnit: '%'},
  ]

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {name, value} = e.target
    setInputField((prev) => ({...prev, [name]: value}))
  }

  const handleCancel = () => {
    setInputField(initialState) // Reset input fields
    setEditId(null) // Clear edit mode
    setInputError({}) // Clear any input errors
  }

  const selectedComponent = configurationNameOptions.find(
    (component) => component.value === inputField.salaryComponentName
  )

  useEffect(() => {
    const selectedComponent = configurationNameOptions.find(
      (option) => option.value === inputField.salaryComponentName
    )
    if (selectedComponent) {
      setInputField((prev) => ({
        ...prev,
        salaryComponentUnit: selectedComponent.unit,
      }))
    }
  }, [inputField.salaryComponentName])

  return (
    <div className='row g-5 g-xl-8'>
      <div className='col-xl-4'>
        <div className='card card-xl-stretch mb-xl-8'>
          <div className='card-header'>
            <div className='card-title'>
              {editId ? 'Update Configuration' : 'Add Configuration'}
            </div>
          </div>
          <div className='card-body'>
            <form
              onSubmit={(e) => {
                e.preventDefault()
                handleSubmit(
                  inputField,
                  getConfiguration,
                  setConfiguration,
                  setEditId,
                  initialState,
                  setInputField,
                  editId,
                  cancelSubmit,
                  setAPIStatus,
                  setInputError,
                  valiconfigurationLevelForm,
                  setAPIStatus,
                  setIsAddUserModalOpen
                )
              }}
            >
              <div className='mb-3'>
                <label htmlFor='salaryComponentName' className='form-label'>
                  Configuration Name
                </label>
                <select
                  className={`form-control ${inputError.salaryComponentName ? 'is-invalid' : ''}`}
                  id='salaryComponentName'
                  name='salaryComponentName'
                  value={inputField.salaryComponentName}
                  onChange={handleChange}
                >
                  <option value='' disabled>
                    Select Configuration
                  </option>
                  {configurationNameOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
                {inputError.salaryComponentName && (
                  <div className='invalid-feedback'>{inputError.salaryComponentName}</div>
                )}
              </div>
              <div className='mb-3'>
                <label htmlFor='salaryComponentValue' className='form-label fw-semibold'>
                  Value{' '}
                  {selectedComponent?.displayUnit ? `(In ${selectedComponent.displayUnit})` : ''}
                </label>
                <input
                  className={`form-control ${inputError.salaryComponentValue ? 'is-invalid' : ''}`}
                  type='text'
                  placeholder='Configuration Value'
                  id='salaryComponentValue'
                  name='salaryComponentValue'
                  value={inputField.salaryComponentValue}
                  onChange={handleChange}
                  disabled={!inputField.salaryComponentName}
                />
                {inputError.salaryComponentValue && (
                  <div className='invalid-feedback'>{inputError.salaryComponentValue}</div>
                )}
              </div>
              <div className='d-flex justify-content-end'>
                <Button variant='secondary' size='sm' onClick={handleCancel}>
                  Cancel
                </Button>
                <Button variant='primary' size='sm' type='submit'>
                  {editId ? 'Update' : 'Save'}
                </Button>
              </div>
            </form> 
          </div>
        </div>
      </div>
      <div className='col-xl-8'>
        <div className='card card-xl-stretch mb-xl-8'>
          <div className='card-header'>
            <div className='card-title'>Configurations</div>
          </div>
          <div className='card-body'>
            {APIStatus.loading ? (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            ) : APIStatus.error != null ? (
              <div className='mb-lg-15 alert alert-danger'>
                <div className='alert-text font-weight-bold'>{APIStatus.error}</div>
              </div>
            ) : (
              <div className='table-responsive'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 table-bordered'>
                  <thead>
                    <tr className='fw-bold text-muted'>
                      <th className='pl-1 text-center text-muted' style={{minWidth: '80px'}}>
                        {changeTextCapital('Sr.No')}
                      </th>
                      <th className='pl-1 flex-start text-muted' style={{minWidth: '150px'}}>
                        {changeTextCapital('Name')}
                      </th>
                      <th className='pl-1 flex-start text-muted' style={{minWidth: '150px'}}>
                        {changeTextCapital('Value')}
                      </th>
                      <th className='pl-1 flex-start text-muted' style={{minWidth: '150px'}}>
                        {changeTextCapital('Unit')}
                      </th>
                      <th className='pl-1 text-center text-muted' style={{minWidth: '100px'}}>
                        {changeTextCapital('Actions')}
                      </th>
                    </tr>
                  </thead>
                  {configuration?.length > 0 ? (
                    <tbody className='text-gray-800 fw-semibold text-left'>
                      {configuration.map((obj, index) => (
                        <tr key={obj?.id}>
                          <td className='text-center'>{index + 1}</td>
                          <td className='flex-start'>
                            {changeTextCapital(obj?.salaryComponentName)}
                          </td>
                          <td className='flex-start'>{obj?.salaryComponentValue ?? '-'}</td>
                          <td className='flex-start'>{obj?.salaryComponentUnit}</td>
                          <td>
                            <div className='d-flex justify-content-center flex-shrink-0'>
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-info btn-sm me-1'
                                onClick={() => {
                                  document.getElementById('salaryComponentName')?.focus()
                                  getConfigurationById(
                                    obj.id,
                                    inputField,
                                    setInputField,
                                    setEditId,
                                    setInputError
                                  )
                                }}
                              >
                                <i className='far fa-edit'></i>
                              </button>
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-1'
                                onClick={() =>
                                  deleteConfiguration(
                                    obj.id,
                                    getConfiguration,
                                    setConfiguration,
                                    setAPIStatus,
                                    cancelSubmit,
                                    setInputField,
                                    initialState,
                                    setEditId,
                                    setInputError
                                  )
                                }
                              >
                                <i className='far fa-trash-alt'></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan={5}>
                          <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                            No Data Found
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Configuration
